import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { errorGuard } from './core/auth/error.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout.routes').then((m) => m.LAYOUT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.routes').then((m) => m.ROUTES),
    canActivate: [],
  },
  {
    path: 'first-login',
    loadChildren: () => import('./pages/first-login/first-login.routes').then((m) => m.ROUTES),
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./pages/terms-and-conditions/terms-and-conditions.routes').then((m) => m.ROUTES),
  },
  {
    path: 'error/:code',
    loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
    canActivate: [errorGuard],
  },
  {
    path: '**',
    loadChildren: () =>
    import('./pages/login/login.routes').then((m) => m.ROUTES),
    canActivate: [],
  },
];
